export class MenuItem{
  public element:HTMLDivElement|null = null
  private label: string = ""
  public onClick:null |(() => void) = null
  constructor(label:string, onClick: () => void){
    this.label = label
    this.onClick = onClick
  }
  public createItem(){
    this.element = document.createElement("div");
    this.element.textContent = this.label;
    this.element.style.padding = "8px 16px";
    this.element.style.cursor = "pointer";
    this.element.style.userSelect = "none";

    this.element.addEventListener("click", () => {
      if(this.onClick){
        this.onClick();
        if(this.element?.parentElement)
          this.element.parentElement.style.display = "none";
      }
      
    });

    this.element.addEventListener("mouseover", () => {
      if(this.element)
        this.element.style.background = "#f1f1f1";
    });

    this.element.addEventListener("mouseout", () => {
      if(this.element)
        this.element.style.background = "white";
    });
  }
}
export class ContextMenu {
    private menu: HTMLDivElement;
    private targetElement: HTMLElement;
    private items: MenuItem[];
    private contextListener: (event: MouseEvent) => void = () => {};
    private clickListener: () => void = () => {};
    private resizeListener: () => void = () => {};


    constructor(targetElement: HTMLElement, items: MenuItem[]) {
      this.targetElement = targetElement;
      this.items = items;
      this.menu = this.createMenu();
      if(items.length > 0)
        this.attachEvents();
    }
    public refreshItems(items: MenuItem[]) {
      this.items = items;
      this.menu.innerHTML = ""; // clear existing menu items
      this.items.forEach((item) => {
        item.createItem();
        if (item.element) this.menu.appendChild(item.element);
      });
    }

  
    private createMenu(): HTMLDivElement {
      // Remove any existing menu element
      if (this.menu && this.menu.parentElement) {
        this.menu.parentElement.removeChild(this.menu);
      }

      const menu = document.createElement("div");
      menu.classList.add("context-menu");
      menu.style.position = "absolute";
      menu.style.display = "none";
      menu.style.background = "white";
      menu.style.border = "1px solid #ccc";
      menu.style.boxShadow = "0px 4px 8px rgba(0, 0, 0, 0.2)";
      menu.style.borderRadius = "5px";
      menu.style.padding = "5px 0";
      menu.style.zIndex = "10000";

      this.items.forEach((item) => {
        item.createItem();
        if (item.element) menu.appendChild(item.element);
      });

      const fullscreenEl = document.fullscreenElement || document.body;
      fullscreenEl.appendChild(menu);
      return menu;
    }

  
    private attachEvents(): void {
      this.contextListener = (event: MouseEvent) => {
        event.preventDefault();
        this.showMenu(event.pageX, event.pageY);
      };
      this.clickListener = () => this.hideMenu();
      this.resizeListener = () => this.hideMenu();

      this.targetElement.addEventListener("contextmenu", this.contextListener);
      document.addEventListener("click", this.clickListener);
      window.addEventListener("resize", this.resizeListener);
    }

  
    private showMenu(x: number, y: number): void {
      this.menu.style.left = `${x}px`;
      this.menu.style.top = `${y}px`;
      this.menu.style.display = "block";
    }
  
    private hideMenu(): void {
      // Remove menu element from the DOM
      if (this.menu && this.menu.parentElement) {
        this.menu.parentElement.removeChild(this.menu);
      }

      // Clear references to help garbage collection
      this.items.forEach(item => {
        if (item.element) {
          item.element.replaceWith(); // safer than removeChild
          item.element = null;
        }
        item.onClick = null;
      });

      // Remove event listeners
      this.targetElement.removeEventListener("contextmenu", this.contextListener);
      document.removeEventListener("click", this.clickListener);
      window.removeEventListener("resize", this.resizeListener);

      // Clear internal references
      this.menu = null!;
      this.items = [];
    }

  }
  